var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from 'redux-saga/effects';
import { FETCH_SYNC_META_REQUEST, fetchStoreSyncMetaSuccess, fetchStoreSyncMetaFailure, } from '../../actions';
import APIIN from '@/utils/APIIN';
const onFetchStoreMetaSync = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const sync = yield APIIN.get(`sync/api/shopify/channel/${action.payload.channelId}/status`, { channelIdList: action.payload.channelId.join(",") });
            resolve(sync);
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchStoreSyncMetaOrderWorker(action) {
    try {
        const data = yield call(onFetchStoreMetaSync, action);
        yield put(fetchStoreSyncMetaSuccess(data));
    }
    catch (error) {
        yield put(fetchStoreSyncMetaFailure(error));
    }
}
export function* watchStoreSyncMetaData() {
    yield takeLatest(FETCH_SYNC_META_REQUEST, fetchStoreSyncMetaOrderWorker);
}
